import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useReservationStore } from 'app/pages/Restaurants/store';

type RouteStateResetConfig = {
  isInScope: (pathname: string) => boolean;
  reset: () => void;
};

const isRestaurantRoute = (pathname: string) =>
  pathname === '/restaurants' || pathname.startsWith('/restaurants/');

const routeStateResetConfigs: RouteStateResetConfig[] = [
  {
    isInScope: isRestaurantRoute,
    reset: () => useReservationStore.getState().resetReservationState(),
  },
];

export const ResetStateOnLeave = () => {
  const location = useLocation();
  const previousPathnameRef = useRef(location.pathname);

  useEffect(() => {
    const previousPathname = previousPathnameRef.current;

    routeStateResetConfigs.forEach(({ isInScope, reset }) => {
      if (isInScope(previousPathname) && !isInScope(location.pathname)) {
        reset();
      }
    });

    previousPathnameRef.current = location.pathname;
  }, [location.pathname]);

  return null;
};
